import _ from 'lodash';

const notFound = () => {

	const compiled = _.template(
		'<div id="listing-none-found" class="px2 py3 border-bottom-1 border-light-grey">' +
			'<div class="flex flex-row items-baseline justify-between">' +
				'<h3 class="f6 alt-heading lh1"><%= title %></h3>' +
			'</div>' +
		'</div>'
	);

	let context = {
		title: 'No properties found'
	}

	return compiled(context);

}

const listing = (data) => {

	const compiled = _.template(
		'<li id="listing-<%= id %>" class="flex flex-row border-bottom-1 border-light-grey hover-border-blue cursor-pointer">' +
			'<figure class="flex flex-column self-stretch xmn3 ymn3 md_ymn4 md_xmn4 background-cover" style="background-image: url(<%= thumbnail %>)">' +
			'</figure>' +
			'<ul class="flex flex-column self-stretch flex-grow px2 py1">' +
				'<li class="flex flex-row items-baseline justify-between">' +
					'<h3 class="f8 md_f6 alt-heading lh3"><%= title %></h3>' +
				'</li>' +
				'<li class="flex flex-row items-baseline justify-between">' +
					'<span class="f9 fw600 dark-grey lh3"><%- types %></span>' +
				'</li>' +
				'<li class="flex flex-row items-baseline justify-between">' +
					'<p class="grey f10 mb0 fw600 lh4"><%= subheading %></p>' +
				'</li>' +
			'</ul>' +
			'<ul class="flex flex-column self-stretch pr2 py1 ">' +
				'<li class="flex flex-row items-baseline justify-between align-right">' +
					'<h6 class="md_f5 alt-heading fw800 lh2 x100p">$<%= price %></h6>' +
				'</li>' +
				'<li class="flex flex-row items-baseline justify-between align-right">' +
					'<span class="f9 fw600 dark-grey x100p"><%= beds %></span>' +
				'</li>' +
			'</ul>' +
		'</li>'
	);

	let types = '';
	let i = 0;
	data.types.forEach( (value) =>{
		i++;
		types += value;
		if ( data.types.length !== i ) types += ' / ';
	});

 	let context = {
		id: data.id,
		title: data.title,
		subheading: data.subheading,
		price: data.price,
		types: types,
		beds: (data.beds !== '1') ? data.beds + ' Beds' : '1 Bed',
		thumbnail: data.thumbnail
	}

	return compiled(context);

}

export default {
	notFound,
	listing
}
